import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import PropTypes from "prop-types";

function ColumnsFilter({ tableColumns, setTableColumns, className }) {
  return (
    <Dropdown autoClose="outside" align="end" className={`cf-menu ${className}`}>
      <Dropdown.Toggle variant="primary" id="dropdown-basic">
        Columns
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {tableColumns?.map((column) => (
          <Dropdown.Item
            as="div"
            key={column.field}
            eventKey={column.field}
            active={column.show}
            onClick={() => {
              const derivedTableColumns = tableColumns.map((col) => {
                if (col.field === column.field) {
                  col.show = !col.show;
                }
                return col;
              });
              setTableColumns(derivedTableColumns);
            }}
          >
            <Form.Check
              className="mb-0"
              type="checkbox"
              key={column.field}
              label={column.header}
              checked={column.show}
              // onChange={(e) => {
              //   e.preventDefault();
              // }}
            />
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

ColumnsFilter.propTypes = {
  tableColumns: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
      show: PropTypes.bool.isRequired,
    })
  ).isRequired,
  setTableColumns: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default ColumnsFilter;
